module.exports = __webpack_public_path__ + "img/introducir.e5ac5381.png";